import React from 'react';
import PropTypes from 'prop-types';
import Input from '@welldev-group/rcl-input';
import { CheckBox, I18nText } from '@welldev-group/react-comp-lib';
import toCamelCase from '../../../shared/helper/toCamelCase';

const ChannelSpecificForm = ({
  supplierSpecific,
  setIdentifierOnChange,
  identifier,
  setForFlightOnChange,
  forFlight,
  setForHotelOnChange,
  forHotel,
  setForCarOnChange,
  forCar,
  setSupplierParamsOnChange,
  supplierParams,
  error,
}) => {
  const handleChange = (value, selectedField) => {
    const modifiedSupplierParams = supplierParams.map(param => {
      const modifiedParam = param;
      if (modifiedParam.key === selectedField.key) {
        modifiedParam.value = value;
      }
      return modifiedParam;
    });
    setSupplierParamsOnChange(modifiedSupplierParams);
  };

  return (
    <>
      <div className="col-12 col-bleed-x channel-modal__fields">
        <div className="channel-modal__fields-allowed-fields">
          <Input
            label={I18n.t('components.channel.placeholder.account_identifier')}
            onChange={value => setIdentifierOnChange(value)}
            value={identifier}
            touched={identifier !== null || !!error.accountIdentifier}
            error={error.accountIdentifier}
            required={true}
          />
        </div>
        {supplierParams.map(
          field =>
            field.key !== 'status' && (
              <div className="channel-modal__fields-allowed-fields">
                <Input
                  label={I18n.t(field.key, {
                    scope: 'components.channel.placeholder',
                  })}
                  onChange={value => handleChange(value, field)}
                  name="password"
                  type="password"
                  value={field.value}
                  placeholder={field.placeholder}
                  error={error[toCamelCase(field.key)]}
                  required={true}
                  touched={
                    field.value !== '' || !!error[toCamelCase(field.key)]
                  }
                />
              </div>
            ),
        )}
        {supplierSpecific.isFilteringEnabled && (
          <div>
            <div className="col-4 channel-modal__fields">
              <CheckBox
                label={<I18nText id="channel.label.flight" />}
                onChange={event => setForFlightOnChange(event.target.checked)}
                checked={forFlight}
                required={true}
              />
            </div>
            <div className="col-4 channel-modal__fields">
              <CheckBox
                label={<I18nText id="channel.label.hotel" />}
                onChange={event => setForHotelOnChange(event.target.checked)}
                checked={forHotel}
              />
            </div>
            <div className="col-4 channel-modal__fields">
              <CheckBox
                label={<I18nText id="channel.label.car" />}
                onChange={event => setForCarOnChange(event.target.checked)}
                checked={forCar}
              />
            </div>
          </div>
        )}
      </div>
    </>
  );
};

ChannelSpecificForm.defaultProps = {
  supplierSpecific: null,
  forFlight: null,
  forHotel: null,
  forCar: null,
  identifier: null,
  supplierParams: null,
};

ChannelSpecificForm.defaultProps = {
  error: {},
};

ChannelSpecificForm.propTypes = {
  supplierSpecific: PropTypes.shape({
    accountIdentifier: PropTypes.string,
    forCar: PropTypes.bool,
    forFlight: PropTypes.bool,
    forHotel: PropTypes.bool,
    formNamespace: PropTypes.string,
    isFilteringEnabled: PropTypes.bool,
    type: PropTypes.string,
  }),
  setIdentifierOnChange: PropTypes.func.isRequired,
  identifier: PropTypes.string,
  setForFlightOnChange: PropTypes.func.isRequired,
  forFlight: PropTypes.bool,
  setForHotelOnChange: PropTypes.func.isRequired,
  forHotel: PropTypes.bool,
  setForCarOnChange: PropTypes.func.isRequired,
  forCar: PropTypes.bool,
  setSupplierParamsOnChange: PropTypes.func.isRequired,
  supplierParams: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.number.isRequired,
      value: PropTypes.string.isRequired,
    }),
  ),
  error: PropTypes.objectOf(PropTypes.string),
};

export default ChannelSpecificForm;
